import ENewsLettersInfoContent from './ENewsLettersInfoContent';

export default ENewsLettersInfoContent;
